import { render, staticRenderFns } from "./PublicationOpened03.vue?vue&type=template&id=587d958e"
import script from "./PublicationOpened03.vue?vue&type=script&lang=js"
export * from "./PublicationOpened03.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports